var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.canEdit
      ? _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.files.length > 0,
                expression: "files.length>0",
              },
            ],
            staticClass: "row edit-button-group",
          },
          [
            !_vm.allowEdit
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn--orange",
                    attrs: { id: "settings-general-document-admin-edit" },
                    on: {
                      click: function ($event) {
                        return _vm.enableEdit()
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("action.edit")))]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.allowEdit
              ? _c(
                  "button",
                  {
                    directives: [{ name: "hkldreset", rawName: "v-hkldreset" }],
                    staticClass: "btn btn--darkblue",
                    attrs: { id: "settings-general-document-admin-cancel" },
                    on: {
                      click: function ($event) {
                        return _vm.discardChange()
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("action.cancel")))]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.allowEdit
              ? _c(
                  "button",
                  {
                    directives: [{ name: "hkldreset", rawName: "v-hkldreset" }],
                    staticClass: "btn btn--orange",
                    attrs: { id: "settings-general-document-admin-save" },
                    on: {
                      click: function ($event) {
                        return _vm.save()
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("action.save")))]
                )
              : _vm._e(),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "edit-attachments",
        attrs: { id: "project-docs-attachments" },
      },
      [
        _c(
          "table",
          { staticClass: "tender-tnc-table" },
          [
            _c("thead", { staticClass: "file-upload-th" }, [
              _c("th", { staticClass: "number tender-font" }, [
                _vm._v("\n          #\n        "),
              ]),
              _vm._v(" "),
              _c("th", { staticClass: "filename tender-font" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("tender.attachment.document")) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("th", { staticClass: "description tender-font" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("tender.attachment.description")) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("th", { staticClass: "description tender-font" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("tender.attachment.effectiveFrom")) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("th", { staticClass: "description tender-font" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("tender.attachment.effectiveTo")) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("th", { staticClass: "uploaded-date tender-font" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("tender.attachment.uploadedDate")) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _vm.canDelete ? _c("th") : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "draggable",
              {
                attrs: {
                  options: { handle: ".myHandler" },
                  element: "tbody",
                  list: _vm.pendingUpdateFiles,
                },
              },
              [
                _vm._l(_vm.pendingUpdateFiles, function (item, index) {
                  return [
                    _c("tr", { key: item.id, staticClass: "set-border-top" }, [
                      _c(
                        "td",
                        {
                          staticClass: "number tender-font",
                          class: { myHandler: _vm.allowEdit },
                        },
                        [
                          _c("span", { staticClass: "attachment-index" }, [
                            _vm._v(_vm._s(index + 1)),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "filename tender-font",
                          class: { myHandler: _vm.allowEdit },
                        },
                        [
                          _c(
                            "a",
                            {
                              staticStyle: { "text-decoration": "underline" },
                              on: {
                                click: function ($event) {
                                  return _vm.downloadFile(item.id)
                                },
                              },
                            },
                            [_vm._v(_vm._s(item.filename))]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("td", { staticClass: "description tender-font" }, [
                        _vm.allowEdit
                          ? _c("div", [
                              _c("textarea", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model.lazy",
                                    value: item.description,
                                    expression: "item.description",
                                    modifiers: { lazy: true },
                                  },
                                  { name: "autosize", rawName: "v-autosize" },
                                ],
                                staticClass: "autosize file-upload-desc",
                                domProps: { value: item.description },
                                on: {
                                  change: function ($event) {
                                    return _vm.$set(
                                      item,
                                      "description",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.allowEdit
                          ? _c("div", [
                              _c(
                                "div",
                                { staticClass: "emphasis description-text" },
                                [_c("p", [_vm._v(_vm._s(item.description))])]
                              ),
                            ])
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        { staticClass: "effective-date" },
                        [
                          _c("DatePicker", {
                            class: {
                              "error-highlight":
                                !_vm.isValidEffectiveFromAndTo &&
                                !item.effectiveDate &&
                                item.endDate,
                            },
                            attrs: {
                              disabledPicker:
                                !_vm.allowEdit ||
                                _vm.isDocEffective(item.effectiveDate),
                              format: "DD MMM YYYY",
                              clearButton:
                                _vm.allowEdit &&
                                !_vm.isDocEffective(item.effectiveDate),
                              disabled: _vm.disabledDatesForEffectiveDate(item),
                              calendarButton: true,
                              calendarButtonIcon: "fa fa-calendar",
                              value: _vm.getDayFromDate(item.effectiveDate),
                            },
                            on: {
                              selected: function (val) {
                                return _vm.updateEffectiveDate(val, item)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        { staticClass: "effective-date" },
                        [
                          _c("DatePicker", {
                            attrs: {
                              disabledPicker: !_vm.allowEdit,
                              format: "DD MMM YYYY",
                              clearButton: _vm.allowEdit,
                              disabled: _vm.disabledDatesForEndDate(item),
                              calendarButton: true,
                              calendarButtonIcon: "fa fa-calendar",
                              value: _vm.getDayFromDate(item.endDate),
                            },
                            on: {
                              selected: function (val) {
                                return _vm.updateEndDate(val, item)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "uploaded-at",
                          staticStyle: { "text-align": "right" },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.formatDate(item.createdAt)) +
                              "\n            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.canDelete && _vm.allowEdit
                        ? _c("td", [
                            _c(
                              "div",
                              {
                                staticClass: "file-upload-delete",
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteFile(index, item)
                                  },
                                },
                              },
                              [_vm._v("\n                ✕\n              ")]
                            ),
                          ])
                        : _vm._e(),
                    ]),
                  ]
                }),
              ],
              2
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.canDownloadAll && _vm.files.length > 0,
                expression: "canDownloadAll && files.length > 0",
              },
            ],
            staticClass: "projects-download-all clearfix",
          },
          [
            _c(
              "button",
              {
                staticClass:
                  "btn btn--darkblue tender-sticky-button float-left",
                on: {
                  click: function ($event) {
                    return _vm.downloadAll(_vm.sourceId)
                  },
                },
              },
              [
                _vm._v(
                  _vm._s(_vm.$t("action.download")) +
                    " " +
                    _vm._s(_vm.$t("all"))
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "float-right clearfix" },
              [_vm._t("buttons")],
              2
            ),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }